/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Prescription_Reason_Heavy_OccupationInputs */

const en_us2_prescription_reason_heavy_occupation = /** @type {(inputs: Prescription_Reason_Heavy_OccupationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% fewer sets: your work is already physical`)
};

const pt_br2_prescription_reason_heavy_occupation = /** @type {(inputs: Prescription_Reason_Heavy_OccupationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% menos séries: seu trabalho já é físico`)
};

const es_419_prescription_reason_heavy_occupation = /** @type {(inputs: Prescription_Reason_Heavy_OccupationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% menos series: tu trabajo ya es físico`)
};

const pt_pt2_prescription_reason_heavy_occupation = /** @type {(inputs: Prescription_Reason_Heavy_OccupationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Menos ${i?.pct}% de séries: o teu trabalho já é físico`)
};

const fr_fr2_prescription_reason_heavy_occupation = /** @type {(inputs: Prescription_Reason_Heavy_OccupationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct} % de séries en moins : ton travail est déjà physique`)
};

const de_de2_prescription_reason_heavy_occupation = /** @type {(inputs: Prescription_Reason_Heavy_OccupationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% weniger Sätze: Deine Arbeit ist schon körperlich`)
};

const it_it2_prescription_reason_heavy_occupation = /** @type {(inputs: Prescription_Reason_Heavy_OccupationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% di serie in meno: il tuo lavoro è già fisico`)
};

/**
* | output |
* | --- |
* | "{pct}% fewer sets: your work is already physical" |
*
* @param {Prescription_Reason_Heavy_OccupationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_heavy_occupation = /** @type {((inputs: Prescription_Reason_Heavy_OccupationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Heavy_OccupationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_heavy_occupation(inputs)
	if (locale === "es-419") return es_419_prescription_reason_heavy_occupation(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_heavy_occupation(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_heavy_occupation(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_heavy_occupation(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_heavy_occupation(inputs)
	return en_us2_prescription_reason_heavy_occupation(inputs)
});
export { prescription_reason_heavy_occupation as "prescription.reason.heavy_occupation" }